// Colour / condition / brand chip labels.
export const FIX6 = {
"fr": {
"col.black": "Noir",
"col.white": "Blanc",
"col.grey": "Gris",
"col.silver": "Argenté",
"col.gold": "Doré",
"col.brown": "Marron",
"col.beige": "Beige",
"col.red": "Rouge",
"col.pink": "Rose",
"col.orange": "Orange",
"col.yellow": "Jaune",
"col.green": "Vert",
"col.blue": "Bleu",
"col.purple": "Violet",
"col.multi": "Multicolore",
"cond.new": "Neuf",
"cond.veryGood": "Très bon état",
"cond.good": "Bon état",
"cond.worn": "Usé",
"cond.damaged": "Abîmé",
"col.max": "Jusqu'à 3 couleurs",
"brand.other": "Autre",
"brand.unknown": "Je ne sais pas",
"brand.otherPh": "Nom de la marque"
},
"en": {
"col.black": "Black",
"col.white": "White",
"col.grey": "Grey",
"col.silver": "Silver",
"col.gold": "Gold",
"col.brown": "Brown",
"col.beige": "Beige",
"col.red": "Red",
"col.pink": "Pink",
"col.orange": "Orange",
"col.yellow": "Yellow",
"col.green": "Green",
"col.blue": "Blue",
"col.purple": "Purple",
"col.multi": "Multicolour",
"cond.new": "New",
"cond.veryGood": "Very good",
"cond.good": "Good",
"cond.worn": "Worn",
"cond.damaged": "Damaged",
"col.max": "Up to 3 colours",
"brand.other": "Other",
"brand.unknown": "I don't know",
"brand.otherPh": "Brand name"
},
"es": {
"col.black": "Negro",
"col.white": "Blanco",
"col.grey": "Gris",
"col.silver": "Plateado",
"col.gold": "Dorado",
"col.brown": "Marrón",
"col.beige": "Beige",
"col.red": "Rojo",
"col.pink": "Rosa",
"col.orange": "Naranja",
"col.yellow": "Amarillo",
"col.green": "Verde",
"col.blue": "Azul",
"col.purple": "Morado",
"col.multi": "Multicolor",
"cond.new": "Nuevo",
"cond.veryGood": "Muy bueno",
"cond.good": "Bueno",
"cond.worn": "Usado",
"cond.damaged": "Dañado",
"col.max": "Hasta 3 colores",
"brand.other": "Otra",
"brand.unknown": "No lo sé",
"brand.otherPh": "Nombre de la marca"
},
"de": {
"col.black": "Schwarz",
"col.white": "Weiß",
"col.grey": "Grau",
"col.silver": "Silber",
"col.gold": "Gold",
"col.brown": "Braun",
"col.beige": "Beige",
"col.red": "Rot",
"col.pink": "Rosa",
"col.orange": "Orange",
"col.yellow": "Gelb",
"col.green": "Grün",
"col.blue": "Blau",
"col.purple": "Lila",
"col.multi": "Mehrfarbig",
"cond.new": "Neu",
"cond.veryGood": "Sehr gut",
"cond.good": "Gut",
"cond.worn": "Abgenutzt",
"cond.damaged": "Beschädigt",
"col.max": "Bis zu 3 Farben",
"brand.other": "Andere",
"brand.unknown": "Weiß nicht",
"brand.otherPh": "Markenname"
},
"it": {
"col.black": "Nero",
"col.white": "Bianco",
"col.grey": "Grigio",
"col.silver": "Argento",
"col.gold": "Oro",
"col.brown": "Marrone",
"col.beige": "Beige",
"col.red": "Rosso",
"col.pink": "Rosa",
"col.orange": "Arancione",
"col.yellow": "Giallo",
"col.green": "Verde",
"col.blue": "Blu",
"col.purple": "Viola",
"col.multi": "Multicolore",
"cond.new": "Nuovo",
"cond.veryGood": "Ottimo",
"cond.good": "Buono",
"cond.worn": "Usurato",
"cond.damaged": "Danneggiato",
"col.max": "Fino a 3 colori",
"brand.other": "Altro",
"brand.unknown": "Non lo so",
"brand.otherPh": "Nome della marca"
},
"pt": {
"col.black": "Preto",
"col.white": "Branco",
"col.grey": "Cinza",
"col.silver": "Prateado",
"col.gold": "Dourado",
"col.brown": "Castanho",
"col.beige": "Bege",
"col.red": "Vermelho",
"col.pink": "Rosa",
"col.orange": "Laranja",
"col.yellow": "Amarelo",
"col.green": "Verde",
"col.blue": "Azul",
"col.purple": "Roxo",
"col.multi": "Multicolor",
"cond.new": "Novo",
"cond.veryGood": "Muito bom",
"cond.good": "Bom",
"cond.worn": "Usado",
"cond.damaged": "Danificado",
"col.max": "Até 3 cores",
"brand.other": "Outra",
"brand.unknown": "Não sei",
"brand.otherPh": "Nome da marca"
},
"ar": {
"col.black": "أسود",
"col.white": "أبيض",
"col.grey": "رمادي",
"col.silver": "فضي",
"col.gold": "ذهبي",
"col.brown": "بني",
"col.beige": "بيج",
"col.red": "أحمر",
"col.pink": "وردي",
"col.orange": "برتقالي",
"col.yellow": "أصفر",
"col.green": "أخضر",
"col.blue": "أزرق",
"col.purple": "بنفسجي",
"col.multi": "متعدد الألوان",
"cond.new": "جديد",
"cond.veryGood": "جيد جدًا",
"cond.good": "جيد",
"cond.worn": "مستعمل",
"cond.damaged": "تالف",
"col.max": "حتى 3 ألوان",
"brand.other": "أخرى",
"brand.unknown": "لا أعرف",
"brand.otherPh": "اسم العلامة التجارية"
},
"zh": {
"col.black": "黑色",
"col.white": "白色",
"col.grey": "灰色",
"col.silver": "银色",
"col.gold": "金色",
"col.brown": "棕色",
"col.beige": "米色",
"col.red": "红色",
"col.pink": "粉色",
"col.orange": "橙色",
"col.yellow": "黄色",
"col.green": "绿色",
"col.blue": "蓝色",
"col.purple": "紫色",
"col.multi": "多色",
"cond.new": "全新",
"cond.veryGood": "很好",
"cond.good": "良好",
"cond.worn": "有磨损",
"cond.damaged": "已损坏",
"col.max": "最多 3 种颜色",
"brand.other": "其他",
"brand.unknown": "不知道",
"brand.otherPh": "品牌名称"
},
"nl": {
"col.black": "Zwart",
"col.white": "Wit",
"col.grey": "Grijs",
"col.silver": "Zilver",
"col.gold": "Goud",
"col.brown": "Bruin",
"col.beige": "Beige",
"col.red": "Rood",
"col.pink": "Roze",
"col.orange": "Oranje",
"col.yellow": "Geel",
"col.green": "Groen",
"col.blue": "Blauw",
"col.purple": "Paars",
"col.multi": "Meerkleurig",
"cond.new": "Nieuw",
"cond.veryGood": "Zeer goed",
"cond.good": "Goed",
"cond.worn": "Versleten",
"cond.damaged": "Beschadigd",
"col.max": "Maximaal 3 kleuren",
"brand.other": "Ander",
"brand.unknown": "Weet ik niet",
"brand.otherPh": "Merknaam"
},
"pl": {
"col.black": "Czarny",
"col.white": "Biały",
"col.grey": "Szary",
"col.silver": "Srebrny",
"col.gold": "Złoty",
"col.brown": "Brązowy",
"col.beige": "Beżowy",
"col.red": "Czerwony",
"col.pink": "Różowy",
"col.orange": "Pomarańczowy",
"col.yellow": "Żółty",
"col.green": "Zielony",
"col.blue": "Niebieski",
"col.purple": "Fioletowy",
"col.multi": "Wielokolorowy",
"cond.new": "Nowy",
"cond.veryGood": "Bardzo dobry",
"cond.good": "Dobry",
"cond.worn": "Zużyty",
"cond.damaged": "Uszkodzony",
"col.max": "Do 3 kolorów",
"brand.other": "Inna",
"brand.unknown": "Nie wiem",
"brand.otherPh": "Nazwa marki"
},
"ru": {
"col.black": "Чёрный",
"col.white": "Белый",
"col.grey": "Серый",
"col.silver": "Серебристый",
"col.gold": "Золотой",
"col.brown": "Коричневый",
"col.beige": "Бежевый",
"col.red": "Красный",
"col.pink": "Розовый",
"col.orange": "Оранжевый",
"col.yellow": "Жёлтый",
"col.green": "Зелёный",
"col.blue": "Синий",
"col.purple": "Фиолетовый",
"col.multi": "Разноцветный",
"cond.new": "Новый",
"cond.veryGood": "Очень хорошее",
"cond.good": "Хорошее",
"cond.worn": "Изношенный",
"cond.damaged": "Повреждённый",
"col.max": "До 3 цветов",
"brand.other": "Другая",
"brand.unknown": "Не знаю",
"brand.otherPh": "Название бренда"
},
"ja": {
"col.black": "黒",
"col.white": "白",
"col.grey": "グレー",
"col.silver": "シルバー",
"col.gold": "ゴールド",
"col.brown": "茶色",
"col.beige": "ベージュ",
"col.red": "赤",
"col.pink": "ピンク",
"col.orange": "オレンジ",
"col.yellow": "黄色",
"col.green": "緑",
"col.blue": "青",
"col.purple": "紫",
"col.multi": "マルチカラー",
"cond.new": "新品",
"cond.veryGood": "非常に良い",
"cond.good": "良い",
"cond.worn": "使用感あり",
"cond.damaged": "破損あり",
"col.max": "最大3色",
"brand.other": "その他",
"brand.unknown": "わからない",
"brand.otherPh": "ブランド名"
},
"ko": {
"col.black": "검정",
"col.white": "흰색",
"col.grey": "회색",
"col.silver": "은색",
"col.gold": "금색",
"col.brown": "갈색",
"col.beige": "베이지",
"col.red": "빨강",
"col.pink": "분홍",
"col.orange": "주황",
"col.yellow": "노랑",
"col.green": "초록",
"col.blue": "파랑",
"col.purple": "보라",
"col.multi": "멀티컬러",
"cond.new": "새것",
"cond.veryGood": "매우 좋음",
"cond.good": "좋음",
"cond.worn": "사용감 있음",
"cond.damaged": "손상됨",
"col.max": "최대 3가지 색상",
"brand.other": "기타",
"brand.unknown": "모르겠어요",
"brand.otherPh": "브랜드명"
},
"tr": {
"col.black": "Siyah",
"col.white": "Beyaz",
"col.grey": "Gri",
"col.silver": "Gümüş",
"col.gold": "Altın",
"col.brown": "Kahverengi",
"col.beige": "Bej",
"col.red": "Kırmızı",
"col.pink": "Pembe",
"col.orange": "Turuncu",
"col.yellow": "Sarı",
"col.green": "Yeşil",
"col.blue": "Mavi",
"col.purple": "Mor",
"col.multi": "Çok renkli",
"cond.new": "Yeni",
"cond.veryGood": "Çok iyi",
"cond.good": "İyi",
"cond.worn": "Yıpranmış",
"cond.damaged": "Hasarlı",
"col.max": "En fazla 3 renk",
"brand.other": "Diğer",
"brand.unknown": "Bilmiyorum",
"brand.otherPh": "Marka adı"
},
"uk": {
"col.black": "Чорний",
"col.white": "Білий",
"col.grey": "Сірий",
"col.silver": "Сріблястий",
"col.gold": "Золотий",
"col.brown": "Коричневий",
"col.beige": "Бежевий",
"col.red": "Червоний",
"col.pink": "Рожевий",
"col.orange": "Помаранчевий",
"col.yellow": "Жовтий",
"col.green": "Зелений",
"col.blue": "Синій",
"col.purple": "Фіолетовий",
"col.multi": "Різнокольоровий",
"cond.new": "Новий",
"cond.veryGood": "Дуже добрий",
"cond.good": "Добрий",
"cond.worn": "Зношений",
"cond.damaged": "Пошкоджений",
"col.max": "До 3 кольорів",
"brand.other": "Інша",
"brand.unknown": "Не знаю",
"brand.otherPh": "Назва бренду"
},
"he": {
"col.black": "שחור",
"col.white": "לבן",
"col.grey": "אפור",
"col.silver": "כסוף",
"col.gold": "זהוב",
"col.brown": "חום",
"col.beige": "בז'",
"col.red": "אדום",
"col.pink": "ורוד",
"col.orange": "כתום",
"col.yellow": "צהוב",
"col.green": "ירוק",
"col.blue": "כחול",
"col.purple": "סגול",
"col.multi": "צבעוני",
"cond.new": "חדש",
"cond.veryGood": "טוב מאוד",
"cond.good": "טוב",
"cond.worn": "משומש",
"cond.damaged": "פגום",
"col.max": "עד 3 צבעים",
"brand.other": "אחר",
"brand.unknown": "לא יודע/ת",
"brand.otherPh": "שם המותג"
},
"hi": {
"col.black": "काला",
"col.white": "सफ़ेद",
"col.grey": "स्लेटी",
"col.silver": "चांदी",
"col.gold": "सुनहरा",
"col.brown": "भूरा",
"col.beige": "बेज",
"col.red": "लाल",
"col.pink": "गुलाबी",
"col.orange": "नारंगी",
"col.yellow": "पीला",
"col.green": "हरा",
"col.blue": "नीला",
"col.purple": "बैंगनी",
"col.multi": "बहुरंगी",
"cond.new": "नया",
"cond.veryGood": "बहुत अच्छा",
"cond.good": "अच्छा",
"cond.worn": "घिसा हुआ",
"cond.damaged": "क्षतिग्रस्त",
"col.max": "अधिकतम 3 रंग",
"brand.other": "अन्य",
"brand.unknown": "पता नहीं",
"brand.otherPh": "ब्रांड का नाम"
},
"id": {
"col.black": "Hitam",
"col.white": "Putih",
"col.grey": "Abu-abu",
"col.silver": "Perak",
"col.gold": "Emas",
"col.brown": "Cokelat",
"col.beige": "Krem",
"col.red": "Merah",
"col.pink": "Merah muda",
"col.orange": "Oranye",
"col.yellow": "Kuning",
"col.green": "Hijau",
"col.blue": "Biru",
"col.purple": "Ungu",
"col.multi": "Multiwarna",
"cond.new": "Baru",
"cond.veryGood": "Sangat baik",
"cond.good": "Baik",
"cond.worn": "Usang",
"cond.damaged": "Rusak",
"col.max": "Maksimal 3 warna",
"brand.other": "Lainnya",
"brand.unknown": "Tidak tahu",
"brand.otherPh": "Nama merek"
},
"th": {
"col.black": "ดำ",
"col.white": "ขาว",
"col.grey": "เทา",
"col.silver": "เงิน",
"col.gold": "ทอง",
"col.brown": "น้ำตาล",
"col.beige": "เบจ",
"col.red": "แดง",
"col.pink": "ชมพู",
"col.orange": "ส้ม",
"col.yellow": "เหลือง",
"col.green": "เขียว",
"col.blue": "น้ำเงิน",
"col.purple": "ม่วง",
"col.multi": "หลายสี",
"cond.new": "ใหม่",
"cond.veryGood": "ดีมาก",
"cond.good": "ดี",
"cond.worn": "มีร่องรอยใช้งาน",
"cond.damaged": "ชำรุด",
"col.max": "สูงสุด 3 สี",
"brand.other": "อื่น ๆ",
"brand.unknown": "ไม่ทราบ",
"brand.otherPh": "ชื่อแบรนด์"
},
"vi": {
"col.black": "Đen",
"col.white": "Trắng",
"col.grey": "Xám",
"col.silver": "Bạc",
"col.gold": "Vàng kim",
"col.brown": "Nâu",
"col.beige": "Be",
"col.red": "Đỏ",
"col.pink": "Hồng",
"col.orange": "Cam",
"col.yellow": "Vàng",
"col.green": "Xanh lá",
"col.blue": "Xanh dương",
"col.purple": "Tím",
"col.multi": "Nhiều màu",
"cond.new": "Mới",
"cond.veryGood": "Rất tốt",
"cond.good": "Tốt",
"cond.worn": "Đã cũ",
"cond.damaged": "Hư hỏng",
"col.max": "Tối đa 3 màu",
"brand.other": "Khác",
"brand.unknown": "Không biết",
"brand.otherPh": "Tên thương hiệu"
},
"sv": {
"col.black": "Svart",
"col.white": "Vit",
"col.grey": "Grå",
"col.silver": "Silver",
"col.gold": "Guld",
"col.brown": "Brun",
"col.beige": "Beige",
"col.red": "Röd",
"col.pink": "Rosa",
"col.orange": "Orange",
"col.yellow": "Gul",
"col.green": "Grön",
"col.blue": "Blå",
"col.purple": "Lila",
"col.multi": "Flerfärgad",
"cond.new": "Ny",
"cond.veryGood": "Mycket bra",
"cond.good": "Bra",
"cond.worn": "Sliten",
"cond.damaged": "Skadad",
"col.max": "Upp till 3 färger",
"brand.other": "Annat",
"brand.unknown": "Vet inte",
"brand.otherPh": "Varumärke"
},
"fi": {
"col.black": "Musta",
"col.white": "Valkoinen",
"col.grey": "Harmaa",
"col.silver": "Hopea",
"col.gold": "Kulta",
"col.brown": "Ruskea",
"col.beige": "Beige",
"col.red": "Punainen",
"col.pink": "Vaaleanpunainen",
"col.orange": "Oranssi",
"col.yellow": "Keltainen",
"col.green": "Vihreä",
"col.blue": "Sininen",
"col.purple": "Violetti",
"col.multi": "Monivärinen",
"cond.new": "Uusi",
"cond.veryGood": "Erittäin hyvä",
"cond.good": "Hyvä",
"cond.worn": "Kulunut",
"cond.damaged": "Vaurioitunut",
"col.max": "Enintään 3 väriä",
"brand.other": "Muu",
"brand.unknown": "En tiedä",
"brand.otherPh": "Merkin nimi"
},
"no": {
"col.black": "Svart",
"col.white": "Hvit",
"col.grey": "Grå",
"col.silver": "Sølv",
"col.gold": "Gull",
"col.brown": "Brun",
"col.beige": "Beige",
"col.red": "Rød",
"col.pink": "Rosa",
"col.orange": "Oransje",
"col.yellow": "Gul",
"col.green": "Grønn",
"col.blue": "Blå",
"col.purple": "Lilla",
"col.multi": "Flerfarget",
"cond.new": "Ny",
"cond.veryGood": "Svært god",
"cond.good": "God",
"cond.worn": "Slitt",
"cond.damaged": "Skadet",
"col.max": "Opptil 3 farger",
"brand.other": "Annet",
"brand.unknown": "Vet ikke",
"brand.otherPh": "Merkenavn"
},
"da": {
"col.black": "Sort",
"col.white": "Hvid",
"col.grey": "Grå",
"col.silver": "Sølv",
"col.gold": "Guld",
"col.brown": "Brun",
"col.beige": "Beige",
"col.red": "Rød",
"col.pink": "Lyserød",
"col.orange": "Orange",
"col.yellow": "Gul",
"col.green": "Grøn",
"col.blue": "Blå",
"col.purple": "Lilla",
"col.multi": "Flerfarvet",
"cond.new": "Ny",
"cond.veryGood": "Meget god",
"cond.good": "God",
"cond.worn": "Slidt",
"cond.damaged": "Beskadiget",
"col.max": "Op til 3 farver",
"brand.other": "Andet",
"brand.unknown": "Ved ikke",
"brand.otherPh": "Mærkenavn"
},
"el": {
"col.black": "Μαύρο",
"col.white": "Λευκό",
"col.grey": "Γκρι",
"col.silver": "Ασημί",
"col.gold": "Χρυσό",
"col.brown": "Καφέ",
"col.beige": "Μπεζ",
"col.red": "Κόκκινο",
"col.pink": "Ροζ",
"col.orange": "Πορτοκαλί",
"col.yellow": "Κίτρινο",
"col.green": "Πράσινο",
"col.blue": "Μπλε",
"col.purple": "Μωβ",
"col.multi": "Πολύχρωμο",
"cond.new": "Καινούργιο",
"cond.veryGood": "Πολύ καλό",
"cond.good": "Καλό",
"cond.worn": "Φθαρμένο",
"cond.damaged": "Κατεστραμμένο",
"col.max": "Έως 3 χρώματα",
"brand.other": "Άλλο",
"brand.unknown": "Δεν ξέρω",
"brand.otherPh": "Όνομα μάρκας"
},
"cs": {
"col.black": "Černá",
"col.white": "Bílá",
"col.grey": "Šedá",
"col.silver": "Stříbrná",
"col.gold": "Zlatá",
"col.brown": "Hnědá",
"col.beige": "Béžová",
"col.red": "Červená",
"col.pink": "Růžová",
"col.orange": "Oranžová",
"col.yellow": "Žlutá",
"col.green": "Zelená",
"col.blue": "Modrá",
"col.purple": "Fialová",
"col.multi": "Vícebarevná",
"cond.new": "Nový",
"cond.veryGood": "Velmi dobrý",
"cond.good": "Dobrý",
"cond.worn": "Opotřebený",
"cond.damaged": "Poškozený",
"col.max": "Až 3 barvy",
"brand.other": "Jiná",
"brand.unknown": "Nevím",
"brand.otherPh": "Název značky"
},
"ro": {
"col.black": "Negru",
"col.white": "Alb",
"col.grey": "Gri",
"col.silver": "Argintiu",
"col.gold": "Auriu",
"col.brown": "Maro",
"col.beige": "Bej",
"col.red": "Roșu",
"col.pink": "Roz",
"col.orange": "Portocaliu",
"col.yellow": "Galben",
"col.green": "Verde",
"col.blue": "Albastru",
"col.purple": "Mov",
"col.multi": "Multicolor",
"cond.new": "Nou",
"cond.veryGood": "Foarte bun",
"cond.good": "Bun",
"cond.worn": "Uzat",
"cond.damaged": "Deteriorat",
"col.max": "Până la 3 culori",
"brand.other": "Alta",
"brand.unknown": "Nu știu",
"brand.otherPh": "Numele mărcii"
},
"hu": {
"col.black": "Fekete",
"col.white": "Fehér",
"col.grey": "Szürke",
"col.silver": "Ezüst",
"col.gold": "Arany",
"col.brown": "Barna",
"col.beige": "Bézs",
"col.red": "Piros",
"col.pink": "Rózsaszín",
"col.orange": "Narancs",
"col.yellow": "Sárga",
"col.green": "Zöld",
"col.blue": "Kék",
"col.purple": "Lila",
"col.multi": "Többszínű",
"cond.new": "Új",
"cond.veryGood": "Nagyon jó",
"cond.good": "Jó",
"cond.worn": "Kopott",
"cond.damaged": "Sérült",
"col.max": "Legfeljebb 3 szín",
"brand.other": "Egyéb",
"brand.unknown": "Nem tudom",
"brand.otherPh": "Márkanév"
},
"sk": {
"col.black": "Čierna",
"col.white": "Biela",
"col.grey": "Sivá",
"col.silver": "Strieborná",
"col.gold": "Zlatá",
"col.brown": "Hnedá",
"col.beige": "Béžová",
"col.red": "Červená",
"col.pink": "Ružová",
"col.orange": "Oranžová",
"col.yellow": "Žltá",
"col.green": "Zelená",
"col.blue": "Modrá",
"col.purple": "Fialová",
"col.multi": "Viacfarebná",
"cond.new": "Nový",
"cond.veryGood": "Veľmi dobrý",
"cond.good": "Dobrý",
"cond.worn": "Opotrebovaný",
"cond.damaged": "Poškodený",
"col.max": "Až 3 farby",
"brand.other": "Iná",
"brand.unknown": "Neviem",
"brand.otherPh": "Názov značky"
},
"bg": {
"col.black": "Черен",
"col.white": "Бял",
"col.grey": "Сив",
"col.silver": "Сребрист",
"col.gold": "Златист",
"col.brown": "Кафяв",
"col.beige": "Бежов",
"col.red": "Червен",
"col.pink": "Розов",
"col.orange": "Оранжев",
"col.yellow": "Жълт",
"col.green": "Зелен",
"col.blue": "Син",
"col.purple": "Лилав",
"col.multi": "Многоцветен",
"cond.new": "Нов",
"cond.veryGood": "Много добро",
"cond.good": "Добро",
"cond.worn": "Износен",
"cond.damaged": "Повреден",
"col.max": "До 3 цвята",
"brand.other": "Друга",
"brand.unknown": "Не знам",
"brand.otherPh": "Име на марката"
},
"hr": {
"col.black": "Crna",
"col.white": "Bijela",
"col.grey": "Siva",
"col.silver": "Srebrna",
"col.gold": "Zlatna",
"col.brown": "Smeđa",
"col.beige": "Bež",
"col.red": "Crvena",
"col.pink": "Ružičasta",
"col.orange": "Narančasta",
"col.yellow": "Žuta",
"col.green": "Zelena",
"col.blue": "Plava",
"col.purple": "Ljubičasta",
"col.multi": "Višebojna",
"cond.new": "Novo",
"cond.veryGood": "Vrlo dobro",
"cond.good": "Dobro",
"cond.worn": "Istrošeno",
"cond.damaged": "Oštećeno",
"col.max": "Do 3 boje",
"brand.other": "Ostalo",
"brand.unknown": "Ne znam",
"brand.otherPh": "Naziv marke"
},
"ca": {
"col.black": "Negre",
"col.white": "Blanc",
"col.grey": "Gris",
"col.silver": "Platejat",
"col.gold": "Daurat",
"col.brown": "Marró",
"col.beige": "Beix",
"col.red": "Vermell",
"col.pink": "Rosa",
"col.orange": "Taronja",
"col.yellow": "Groc",
"col.green": "Verd",
"col.blue": "Blau",
"col.purple": "Lila",
"col.multi": "Multicolor",
"cond.new": "Nou",
"cond.veryGood": "Molt bo",
"cond.good": "Bo",
"cond.worn": "Gastat",
"cond.damaged": "Malmès",
"col.max": "Fins a 3 colors",
"brand.other": "Altra",
"brand.unknown": "No ho sé",
"brand.otherPh": "Nom de la marca"
}
};

const PH = {"fr": "Ce numéro sera ajouté à votre compte.", "en": "This number will be added to your account.", "es": "Este número se añadirá a tu cuenta.", "de": "Diese Nummer wird Ihrem Konto hinzugefügt.", "it": "Questo numero verrà aggiunto al tuo account.", "pt": "Este número será adicionado à sua conta.", "ar": "ستتم إضافة هذا الرقم إلى حسابك.", "zh": "该号码将添加到您的账户。", "nl": "Dit nummer wordt aan je account toegevoegd.", "pl": "Ten numer zostanie dodany do Twojego konta.", "ru": "Этот номер будет добавлен в ваш аккаунт.", "ja": "この番号はアカウントに追加されます。", "ko": "이 번호가 계정에 추가됩니다.", "tr": "Bu numara hesabınıza eklenecek.", "uk": "Цей номер буде додано до вашого акаунта.", "he": "המספר יתווסף לחשבון שלך.", "hi": "यह नंबर आपके खाते में जोड़ा जाएगा।", "id": "Nomor ini akan ditambahkan ke akun Anda.", "th": "หมายเลขนี้จะถูกเพิ่มในบัญชีของคุณ", "vi": "Số này sẽ được thêm vào tài khoản của bạn.", "sv": "Numret läggs till på ditt konto.", "fi": "Numero lisätään tiliisi.", "no": "Nummeret legges til kontoen din.", "da": "Nummeret føjes til din konto.", "el": "Ο αριθμός θα προστεθεί στον λογαριασμό σας.", "cs": "Toto číslo bude přidáno k vašemu účtu.", "ro": "Acest număr va fi adăugat în contul tău.", "hu": "Ez a szám a fiókodhoz lesz adva.", "sk": "Toto číslo bude pridané k vášmu účtu.", "bg": "Този номер ще бъде добавен към профила ви.", "hr": "Ovaj broj bit će dodan vašem računu.", "ca": "Aquest número s'afegirà al teu compte."};
for (const k of Object.keys(PH)) FIX6[k] = { ...FIX6[k], "acc.phoneSaved": PH[k] };

const PR = {"fr": "Indiquez votre numéro de téléphone pour publier.", "en": "Please enter your phone number to publish.", "es": "Indica tu número de teléfono para publicar.", "de": "Bitte geben Sie Ihre Telefonnummer ein, um zu veröffentlichen.", "it": "Inserisci il tuo numero di telefono per pubblicare.", "pt": "Indique o seu número de telefone para publicar.", "ar": "يرجى إدخال رقم هاتفك للنشر.", "zh": "请填写您的电话号码后发布。", "nl": "Vul je telefoonnummer in om te publiceren.", "pl": "Podaj numer telefonu, aby opublikować.", "ru": "Укажите номер телефона, чтобы опубликовать.", "ja": "公開するには電話番号を入力してください。", "ko": "게시하려면 전화번호를 입력하세요.", "tr": "Yayınlamak için telefon numaranızı girin.", "uk": "Вкажіть номер телефону, щоб опублікувати.", "he": "הזינו מספר טלפון כדי לפרסם.", "hi": "प्रकाशित करने के लिए अपना फ़ोन नंबर दर्ज करें।", "id": "Masukkan nomor telepon Anda untuk menerbitkan.", "th": "กรุณากรอกหมายเลขโทรศัพท์เพื่อเผยแพร่", "vi": "Vui lòng nhập số điện thoại để đăng.", "sv": "Ange ditt telefonnummer för att publicera.", "fi": "Anna puhelinnumerosi julkaistaksesi.", "no": "Oppgi telefonnummeret ditt for å publisere.", "da": "Angiv dit telefonnummer for at udgive.", "el": "Εισαγάγετε τον αριθμό τηλεφώνου σας για δημοσίευση.", "cs": "Pro zveřejnění zadejte telefonní číslo.", "ro": "Introdu numărul de telefon pentru a publica.", "hu": "A közzétételhez add meg a telefonszámod.", "sk": "Na zverejnenie zadajte telefónne číslo.", "bg": "Въведете телефонния си номер, за да публикувате.", "hr": "Unesite broj telefona za objavu.", "ca": "Indica el teu número de telèfon per publicar."};
for (const k of Object.keys(PR)) FIX6[k] = { ...FIX6[k], "acc.phoneRequired": PR[k] };
